export const locale = {
  lang: 'en',
  data: {
    'SALE': {
      'DATA_MANAGEMENT': 'Data Management',
      'PAYMENT_HISTORY': 'Payment data',
      'MASTER_LIST': 'Master list',
      'DATA_RECONCILIATION': 'Data reconciliation',
      'TO_BE_RECONCILE_DATA': 'To be reconciled',
      'TRANSACTION_NOT_FOUND': 'Transaction not found',
      'ORDER_NOT_FOUND': 'Order not found',
      'SYNCHRONIZATION_LOG': 'Synchronization log'
    },
    'SERVER_ERROR': 'Something went wrong. Please contact IT Department to support',
  }
};
